import React from "react";
import { AddPlanGroupContainer } from "../../../containers";

const AddPlanGroup = (props) => {
  return <AddPlanGroupContainer {...props} />;
};

export default AddPlanGroup;
